import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-system-configuration',
    template: `
    <div class="p-3">
      <router-outlet></router-outlet>
    </div>
  `,
    standalone: false
})
export class SystemConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
